import { makeStyles } from '@material-ui/core/styles'
import { Box, TextField, Typography } from '@material-ui/core'
import Mapir from 'mapir-react-component'
import { connect } from 'react-redux'
import {
	originLocationSelected,
	changeOriginAddress,
	changeDestinationAddress,
	destinationLocationSelected,
	paths,
	resetState,
} from '../actions/actionCreators'
import {
	RESET_DESTINATION,
	UPDATE_DESTINATION_LATLNG,
	UPDATE_ORIGIN_LATLNG,
} from '../actions/actionsTypes'
import { push } from 'connected-react-router'
import ButtonWithLoading from '../new-ui/components/ButtonWithLoading'
import { useLocation } from 'react-router-dom'
import i18n from '../i18nextInitiator'
import { useEffect, useState } from 'react'
import { store } from '../store'
import axios from 'axios'
import polyline from 'google-polyline'
import { Close, Place } from '@material-ui/icons'
import { compose } from 'redux'
import referralWrapper from '../new-ui/components/Authentication/Referral/ReferralWrapper'

const Map = Mapir.setToken({
	transformRequest: (url) => {
		return {
			url: url,
			headers: {
				'x-api-key':
					'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIn0.eyJhdWQiOiIxNjA3MCIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIiwiaWF0IjoxNjM2OTcyNTY0LCJuYmYiOjE2MzY5NzI1NjQsImV4cCI6MTYzOTQ3ODE2NCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.o26dFrwtrZsfqK6IDhTXFOEh3au30e11II45RILpeRMpS5K8T6Q_nla7MnpZnxDNXiliGqHd5E2OWMCGdfIc5OfbB8GZUtW0zxU-pQP-wbvedZ1xmUfyq_yMw3XbsWDvQlXwcDRy2ouT6f2riUIz_zyxJ4lFki2PxLj2A-wAnxDqNS7SA7co-dwn9WRd_4uNROAhvQk7lCd-5nQJVL31UljiKVoRiy819T-V2S4HEuZBfixUto-pXA6Q53e4-YaRXmrM9p0ZSm-cfhX8Pwis4MucjrxjD6qvQv19aJ2HA6NzG1gYgcm0yeFZ5m9kCbg1P6XrRxU13-G8diLI_Vyn5w', //Mapir api key
				'Mapir-SDK': 'reactjs',
			},
		}
	},
})

const useStyles = makeStyles((theme) => ({
	root: {
		height: 'calc(100vh - 66px)',
		position: 'relative',
		overflow: 'hidden',
		[theme.breakpoints.down('sm')]: {
			height: 'calc(100vh - 74px)',
		},
	},
	centeredMarker: {
		width: '45px',
		height: '45px',
		position: 'absolute',
		zIndex: 1000,
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -100%)',
		cursor: 'pointer',
	},
	searchBox: {
		position: 'absolute',
		top: '10px',
		zIndex: 1200,
		marginRight: 'auto',
		marginLeft: 'auto',
		left: 0,
		right: 0,
		width: '90%',
		maxWidth: '600px',
	},
	inputContainer: {
		backgroundColor: 'white',
		borderRadius: '6px',
		maxWidth: '600px',
	},
	searchButton: {
		position: 'absolute',
		top: '50%',
		transform: ' translateY(-50%)',
		right: 0,
		backgroundColor: 'orange',
		height: '100%',
		width: '60px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '0 6px 6px 0',
	},
	searchInput: {
		width: '100%',
		transition: 'all 300ms ease-in-out',
	},
	resultContainer: {
		position: 'absolute',
		top: '60px',
		borderRadius: '6px',
		backgroundColor: 'white',
		zIndex: 1200,
		marginRight: 'auto',
		marginLeft: 'auto',
		left: 0,
		right: 0,
		padding: '20px',
		maxWidth: '600px',
		overflow: 'auto',
		maxHeight: '40vh',
		'&::-webkit-scrollbar': {
			width: '6px',
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#e6e6e6',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'rgba(0,0,0,.1)',
			borderRadius: '0.5rem',
		},
	},
	searchResult: {
		marginBottom: '16px',
		transition: 'all 300ms ease-in-out',
		cursor: 'pointer',
		padding: '5px',
		'&:hover': {
			padding: '10px',
			backgroundColor: '#e6e6e6',
			borderRadius: '6px',
		},
	},
	resultTitle: {
		marginBottom: '8px',
	},
}))

const t = i18n.getFixedT('fa', 'location')

const NewLocation = (props) => {
	const classes = useStyles()
	const location = useLocation()

	const [text, setText] = useState('')
	const [results, setResults] = useState([])

	const {
		firstPage,
		order: { startAddressLat },
	} = props

	const [mapCenter, setMapCenter] = useState([51.391151, 35.700944])

	const [route, setRoute] = useState(null)

	const destSelected = (data) => {
		props.destinationLocationSelected(data)
	}

	const onConfirmLocation = () => {
		if (location.pathname.includes(paths.selectDestination)) {
			destSelected(props.map.markerTo)
		} else {
			originLocationSelected(props.map.marker)
		}
	}

	const onLocationClick = (lngLat) => {
		setMapCenter([lngLat[0], lngLat[1]])
		store.dispatch({
			type: location.pathname.includes(paths.selectDestination)
				? UPDATE_DESTINATION_LATLNG
				: UPDATE_ORIGIN_LATLNG,
			latlng: { lat: lngLat[1], lng: lngLat[0] },
		})
		clearSearch()
	}

	const updateLocation = ({ lat, lng }) => {
		if (!window.location.pathname.includes(paths.selectDestination)) {
			localStorage.setItem('originLat', lat)
			localStorage.setItem('originLng', lng)
		}
		setMapCenter([lng, lat])
		if (window.location.pathname.includes(paths.selectDestination)) {
			getRoute({ lng, lat })
		}
		store.dispatch({
			type: window.location.pathname.includes(paths.selectDestination)
				? UPDATE_DESTINATION_LATLNG
				: UPDATE_ORIGIN_LATLNG,
			latlng: { lat: lat, lng: lng },
		})
	}

	// Search API
	const search = (params) => {
		return fetch(`https://map.ir/search/v2/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-api-key':
					'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIn0.eyJhdWQiOiIxNjA3MCIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIiwiaWF0IjoxNjM2OTcyNTY0LCJuYmYiOjE2MzY5NzI1NjQsImV4cCI6MTYzOTQ3ODE2NCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.o26dFrwtrZsfqK6IDhTXFOEh3au30e11II45RILpeRMpS5K8T6Q_nla7MnpZnxDNXiliGqHd5E2OWMCGdfIc5OfbB8GZUtW0zxU-pQP-wbvedZ1xmUfyq_yMw3XbsWDvQlXwcDRy2ouT6f2riUIz_zyxJ4lFki2PxLj2A-wAnxDqNS7SA7co-dwn9WRd_4uNROAhvQk7lCd-5nQJVL31UljiKVoRiy819T-V2S4HEuZBfixUto-pXA6Q53e4-YaRXmrM9p0ZSm-cfhX8Pwis4MucjrxjD6qvQv19aJ2HA6NzG1gYgcm0yeFZ5m9kCbg1P6XrRxU13-G8diLI_Vyn5w',
			},
			body: JSON.stringify(params),
		})
	}

	const getRoute = (lngLat) => {
		axios
			.get(
				`https://map.ir/routes/route/v1/driving/${localStorage.getItem(
					'originLng'
				)},${localStorage.getItem('originLat')};${lngLat.lng},${lngLat.lat}`,
				{
					headers: {
						'Content-Type': 'application/json',
						'x-api-key':
							'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIn0.eyJhdWQiOiIxNjA3MCIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIiwiaWF0IjoxNjM2OTcyNTY0LCJuYmYiOjE2MzY5NzI1NjQsImV4cCI6MTYzOTQ3ODE2NCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.o26dFrwtrZsfqK6IDhTXFOEh3au30e11II45RILpeRMpS5K8T6Q_nla7MnpZnxDNXiliGqHd5E2OWMCGdfIc5OfbB8GZUtW0zxU-pQP-wbvedZ1xmUfyq_yMw3XbsWDvQlXwcDRy2ouT6f2riUIz_zyxJ4lFki2PxLj2A-wAnxDqNS7SA7co-dwn9WRd_4uNROAhvQk7lCd-5nQJVL31UljiKVoRiy819T-V2S4HEuZBfixUto-pXA6Q53e4-YaRXmrM9p0ZSm-cfhX8Pwis4MucjrxjD6qvQv19aJ2HA6NzG1gYgcm0yeFZ5m9kCbg1P6XrRxU13-G8diLI_Vyn5w',
					},
				}
			)
			.then((result) => {
				const { data } = result
				var decodeResult = polyline.decode(data.routes[0].geometry)
				var reverseLatLon = decodeResult.map((items, _) => items.reverse())
				var geojsonpoint = {
					type: 'FeatureCollection',
					features: [
						{
							type: 'Feature',
							properties: {},
							geometry: {
								type: 'LineString',
								coordinates: reverseLatLon,
							},
						},
					],
				}
				setRoute(
					<Mapir.GeoJSONLayer
						data={geojsonpoint}
						linePaint={{
							'line-color': '#f16136',
							'line-width': 3,
						}}
						key={1}
					/>
				)
			})
	}

	function clearSearch() {
		setResults([])
		setText('')
	}

	// useEffect(() => {
	// 	let toRemove = document
	// 		.getElementsByClassName('mapboxgl-ctrl-bottom-right')[0]
	// 		.remove()
	// 	let loc = document.getElementsByClassName('mapboxgl-ctrl-top-right')[0]
	// 	loc.classList.remove('mapboxgl-ctrl-top-right')
	// 	loc.classList.add('mapboxgl-ctrl-bottom-right')
	// }, [])

	useEffect(() => {
		if (text.length > 1) {
			const params = { $filter: 'province eq تهران' }
			const options = { text }
			for (let key in options) {
				if (options[key] !== null && options[key] !== '') {
					params[key] = options[key]
				}
			}
			search(params)
				.then((data) => data.json())
				.then((data) => {
					if (data['odata.count'] > 0) {
						setResults(data.value)
					} else {
						setResults([{ notFound: true }])
					}
				})
		} else if (text.length === 0) {
			setResults([])
		}
	}, [text])

	useEffect(() => {
		if (
			window.location.pathname.includes(paths.selectDestination) &&
			!startAddressLat
		)
			firstPage()
		if (!window.location.pathname.includes(paths.selectDestination))
			resetState()
		// eslint-disable-next-line react-hooks/exhaustive-deps
		props.resetLocations()
	}, [])

	return (
		<Box className={classes.root}>
			<Mapir
				hash={true}
				interactive={true}
				onClick={(_, e) => {
					setMapCenter([e.lngLat.lng, e.lngLat.lat])
					updateLocation({ lat: e.lngLat.lat, lng: e.lngLat.lng })
				}}
				onDragEnd={(map) => {
					const { lng, lat } = map.getCenter()
					updateLocation({ lat, lng })
				}}
				center={mapCenter}
				Map={Map}
				userLocation>
				{window.location.pathname.includes(paths.selectDestination) && (
					<Mapir.Marker
						style={{ maxHeight: '45px', width: '45px' }}
						coordinates={[
							localStorage.getItem('originLng'),
							localStorage.getItem('originLat'),
						]}
						anchor='bottom'
						// onClick={onConfirmLocation}
						Image={'/orders/images/icons/origin-selected-pin.svg'}
					/>
				)}
				<Box onClick={onConfirmLocation} className={classes.centeredMarker}>
					<img
						height='100%'
						width='100%'
						src={
							location.pathname === paths.selectDestination
								? '/orders/images/icons/destination-pin.svg'
								: '/orders/images/icons/origin-pin.svg'
						}
						alt='pin'
					/>
				</Box>
				{route}
			</Mapir>
			<ButtonWithLoading
				style={{
					maxWidth: 600,
					fontSize: '1.3rem',
					position: 'fixed',
					zIndex: 1000,
					bottom: '10px',
					width: '90%',
				}}
				text={
					!window.location.pathname.includes(paths.selectDestination)
						? t('select-origin')
						: t('select-dest')
				}
				action={onConfirmLocation}
				disabled={props.isSelectingLocation}
			/>
			<Box className={classes.searchBox}>
				<Box className={classes.inputContainer}>
					<TextField
						className={classes.searchInput}
						id='outlined-basic'
						label='جستجو'
						value={text}
						variant='outlined'
						InputProps={{
							endAdornment:
								text.length > 0 ? (
									<Close
										onClick={clearSearch}
										style={{
											cursor: 'pointer',
										}}
									/>
								) : null,
						}}
						onChange={(e) => {
							setText(e.target.value)
						}}
					/>
					{results.length > 0 && (
						<div onClick={() => clearSearch()}>
							<span> &#10006; </span>
						</div>
					)}
				</Box>
				{results.length > 0 && (
					<Box className={classes.resultContainer}>
						{results.map((item) => {
							if (item.notFound === true) {
								return <p>نتیجه ای یافت نشد</p>
							} else {
								return (
									<Box
										onClick={() => onLocationClick(item.geom.coordinates)}
										className={classes.searchResult}>
										<Box className={classes.resultTitle}>
											<Place />
											{item.title}
										</Box>
										<Box className={classes.resultTitle}>{item.address}</Box>
									</Box>
								)
							}
						})}
					</Box>
				)}
			</Box>
		</Box>
	)
}

const mapStateToProps = (state) => ({ ...state.order })
const mapDispatchToProps = (dispatch) => ({
	originLocationSelected,
	changeOriginAddress,
	changeDestinationAddress,
	destinationLocationSelected,
	firstPage: () => dispatch(push('/')),
	resetLocations: () => dispatch({ type: RESET_DESTINATION }),
})

export default compose(
	referralWrapper,
	connect(mapStateToProps, mapDispatchToProps)
)(NewLocation)
